import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState, AppThunk } from "../../app/store";
import { fetchCounsellorModule } from "./learningAPI";

export interface CounsellorMState {
  counsellormodule: Array<any>;
  status: "idle" | "loading" | "failed";
}

const initialState: CounsellorMState = {
    counsellormodule: [],
  status: "idle",
};

export const GetCounsellorModule = createAsyncThunk(
  "counsellor/fetchCounsellor",
  async (data:any) => {
    const response = await fetchCounsellorModule(data);
    return response;
  }
);

export const counsellorModuleSlice = createSlice({
  name: "Counsellor",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(GetCounsellorModule.pending, (state) => {
        state.status = "loading";
      })
      .addCase(GetCounsellorModule.rejected, (state) => {
        state.status = "failed";
      })
      .addCase(GetCounsellorModule.fulfilled, (state, action) => {
        state.status = "idle";
        state.counsellormodule = action.payload.material;
        //state.counsellormodule = state.counsellormodule.concat(action.payload.material);
      });
  },
});

export const {} = counsellorModuleSlice.actions;

export const selectCounsellorModule = (state: RootState) => {
  return state.CounsellorModule.counsellormodule;
};

export default counsellorModuleSlice.reducer;
